import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Subscription } from 'rxjs';
import * as XLSX from 'xlsx';
import { AuthGaurdService } from 'src/app/service/auth-gaurd.service';
import { NotificationService } from '../../service/notification.service';
import { NotificationType } from '../../enum/notification-type.enum';
import { CalRunIdModel } from '../../models/config/calrunid.model';
import { Router } from '@angular/router';
import { TableColumn } from 'src/app/home/table/TableColumn';
import { saveAs } from 'file-saver';
import { ExportExcelService } from 'src/app/service/export-excel.service';
import { NgForm } from '@angular/forms';
import { ErrorResponseMessage } from 'src/app/error-handler/error-response-message.model';
import { CalRunIdService } from 'src/app/service/calrunid.service';
import { GlobalService } from 'src/app/service/global.service';

@Component({
  selector: 'app-calrunids',
  templateUrl: './calrunids.component.html',
  styleUrls: ['./calrunids.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class CalrunidsComponent implements OnInit {

  constructor(private globalService: GlobalService,private httpService: HttpClient, private router: Router, private calendarService: CalRunIdService,
    public ete: ExportExcelService, private authGaurdService: AuthGaurdService, private notificationService: NotificationService) { }

  ordersTableColumns: TableColumn[];
  fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  fileExtension = '.xlsx';
  fileName: string = 'CalendarData';
  columnsData: any;
  checked: boolean = false;
  actionButtons: any;
  actions: any;

  selctedValues: CalRunIdModel[] = [];
  isChecked: boolean = false;

  public calcData: CalRunIdModel[] = [];
  public filterData: CalRunIdModel[] = [];


  public calendarModel = new CalRunIdModel('', 0, '', '', '', null, '', null, '', false,'',null,null,'','','','',0,0);

  public loggedinUser: string = '';
  public errorMessage: string = '';
  public sucessMessage: string = '';
  private subscriptions: Subscription[] = [];
  public refreshing: boolean;
  public checkedactive: boolean = false;
  public isTableExpanded = false;
  public showLoading: boolean;
  public fname: string;

  selctedCals: CalRunIdModel[] = [];
  calData: CalRunIdModel[] = [];
  excelCalData: CalRunIdModel[] = [];

  public displayedColumns = ['id', 'calendar_type', 'created_dt', 'updated_dt', 'updated_by'];
  public dataSource = new MatTableDataSource<CalRunIdModel>();

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('TABLE') table: ElementRef;

  columnsExcelData: any;
  dataForExcel = [];
  ordersTableExcelHeaderColumns: TableColumn[];

  isAccessDisabled: boolean = false;

  ngOnInit() {
    //Get Permissions
    this.isAccessDisabled = this.globalService._permissionCheck('manage-calrunid');

    this.initializeColumns();
    this.getCalRunIdList();
    this.initializeExcelHeaders();
  }

   initializeExcelHeaders(): void {
    this.httpService.get('../../../assets/json/excelHeaders.json').subscribe(
      data => {
        this.columnsExcelData = data;
        this.ordersTableExcelHeaderColumns = this.columnsExcelData.calrunids;
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    );
  }

  exportExcel() {
    console.log(this.excelCalData)
    for (let js of this.excelCalData) {
      delete js.id;
      delete js.active_flag;
      delete js.created_dt;
      delete js.created_by;
      delete js.editMode;
      delete js.comment;
      delete js.runControlDesc;
      delete js.runControlName;
      delete js.runCtrlId;
      delete js.comm_plan_id;
      delete js.userId;
      delete js.uid;
      delete js.startTime;
      delete js.updated_by;
      delete js.updated_dt;
    }
    this.dataForExcel = [];
    let reportData = null;
    this.excelCalData.forEach((row: any) => {
      console.log("obj === "+Object.values(row));
      this.dataForExcel.push(Object.values(row));
    })
     reportData = {
      title: 'Calrunids',
      data: this.dataForExcel,
      headers: Object.keys(this.ordersTableExcelHeaderColumns[0])
    }
    this.ete.exportExcel(reportData);
  }

  public insertCalRunId(calcForm: NgForm): void {
    this.showLoading = true;
    const formData = this.calendarService.createCalRunIdForm(calcForm.value);
      this.calendarService.addCalRunId(formData).subscribe(
        (response: CalRunIdModel) => {
          this.clickButton('closeAddButton');
          this.notificationService.sendNotification(NotificationType.SUCCESS, `Calendar Type added successfully`);
          this.getCalRunIdList();
          calcForm.reset();
          this.showLoading = false;
        }, (errorResponse: HttpErrorResponse) => {
          this.showLoading = false;
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      )
  }

  public updateCalRunId(): void {
    const formData = this.calendarService.createCalRunIdForm(this.calendarModel);
    this.subscriptions.push(
      this.calendarService.updateCalRunId(formData).subscribe(
        (response: CalRunIdModel) => {
          this.clickButton('closeEditModalButton');
          this.getCalRunIdList();
          this.notificationService.sendNotification(NotificationType.SUCCESS, `Updated successfully`);
        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      )
    );
  }

  public clickToCloseButton(buttonId: string, calTypeForm: NgForm): void {
    document.getElementById(buttonId).click();
    calTypeForm.reset();
  }

  public clickToEditCloseButton(buttonId: string, calTypeForm: NgForm): void {
    document.getElementById(buttonId).click();
    this.getCalRunIdList();
  }

 

  public getCalRunIdList(): void {
    this.refreshing = true;
    this.subscriptions.push(
      this.calendarService.getCalRunIdList().subscribe(
        (response: CalRunIdModel[]) => {
          this.calData = response;
          this.excelCalData = JSON.parse(JSON.stringify(response));
          //console.log(this.excelCalData);
          this.refreshing = false;

          const filterValue = this._normalizeValue('Active');
          this.filterData = this.calData.filter(comm => this._normalizeValue(comm.active_flag).startsWith(filterValue));
          this.calcData = this.filterData;
        }, (errorResponse: HttpErrorResponse) => {
          this.refreshing = false;
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      )
    );
  }

  private _normalizeValue(value: string): string {
    if (value)
      return value.toLowerCase().replace(/\s/g, '');
    else
      return '';
  }

  public selectedCals(cal: any, values: any) {
    //console.log("cal=" + JSON.stringify(cal));
    //console.log("values=" +JSON.stringify(values));

    if (values.value.currentTarget.checked) {
      this.calendarModel.id = cal.row.id;
      this.selctedCals.push(cal.row);
    } else {
      this.selctedCals.forEach((value: any, index: any) => {
        if (value.id == cal.id) this.selctedCals.splice(index, 1);
      });
    }

    console.log("this.selctedCals=" +JSON.stringify(this.selctedCals));

    this.calendarService.selectedCalcModel = this.selctedCals[0];
    //this.router.navigate(['/' + 'calendar-update']);
  }

  

  private clickButton(buttonId: string): void {
    document.getElementById(buttonId).click();
  }

  public redirect(url: string) {
    this.router.navigate(['/' + url]);
  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  public customSort = (event) => {
    console.log(event);
  }

  public doFilter = (value: string) => {
    this.dataSource.filter = value.trim().toLocaleLowerCase();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  ExportTOExcel() {
    this.ete.exportFromHtmlTable(this.table.nativeElement, 'CalendarData');
  }

  

  public onEdit(calModel: CalRunIdModel): void {
    this.calendarModel = calModel;
    this.clickButton('openEdit');
  }

  innerRowAction1(row: any) {
   
    if (row.value === 'Update') {
      if (this.isAccessDisabled === true) {
        this.notificationService.sendNotification(NotificationType.WARNING, NotificationType.PERMISSIONS_MSG);
      } else {
        this.onEdit(row.row);
      }
     
    }
  }

  initializeColumns(): void {
    this.httpService.get('../../../assets/json/tableColumns.json').subscribe(
      data => {
        this.columnsData = data;
        this.ordersTableColumns = this.columnsData.Calrunid;
        console.log(this.ordersTableColumns);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    );

    this.actions = [
      {
        name: 'Update',
        dataKey: 'far fa-edit success f-25',
        position: 'left',
        isSortable: false,
        class: 'badge bg-success'
      }
    ]

    this.actionButtons = [
      {
        name: 'Add',
        class: 'btn btn-success btn-xs'
      }
    ]

  }

  actionOnButton(action: any) {
    if (action === "Add") {
      if (this.isAccessDisabled === true) {
        this.notificationService.sendNotification(NotificationType.WARNING, NotificationType.PERMISSIONS_MSG);
      } else {
        this.clickButton(action);
      }
    }
  }

  



}
